

















































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import { ProductVariant } from '@/models';

import AddToCartFeature from './buybox/AddToCartFeature.vue';
import BuyNowFeature from './buybox/BuyNowFeature.vue';
import BuyboxBottomPanelFeature from './buybox/BuyboxBottomPanelFeature.vue';
import MobileQuantityFeature from './buybox/MobileQuantityFeature.vue';
import OutOfStockFeature from './OutOfStockFeature.vue';
import PartialStateBuyboxFeature from './PartialStateBuyboxFeature.vue';
import ProductFeature from './ProductFeature';
import QuantityFeature from './buybox/QuantityFeature.vue';

@Component({
  components: {
    AddToCartFeature,
    BuyNowFeature,
    BuyboxBottomPanelFeature,
    MobileQuantityFeature,
    OutOfStockFeature,
    PartialStateBuyboxFeature,
    QuantityFeature,
  },
})
export default class BuyboxFeature extends ProductFeature {
  public quantity: number = 1;

  get isOutOfStock() {
    const inventory = this.variant.inventory;
    return !inventory || (inventory.quantity === 0 && !inventory.restockDate);
  }
}

